import React, { Component } from "react";
import {
	TextField,
	FloatingActionButton,
	Badge,
	RaisedButton
} from "material-ui";
import Description from "material-ui/svg-icons/action/description";
import ContentAdd from "material-ui/svg-icons/content/add";
import SearchIcon from "material-ui/svg-icons/action/search";
import LibraryBooks from "material-ui/svg-icons/av/library-books";
import Check from "material-ui/svg-icons/navigation/check";
import FilterList from "material-ui/svg-icons/content/filter-list";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";

class FilterCard extends Component {
	constructor(props) {
		super(props);
		this.renderFilterButton = this.renderFilterButton.bind(this);
		this.onToggledFilter = this.onToggledFilter.bind(this);
	}

	onToggledFilter() {
		this.props.onToggledFilter();
	}

	renderFilterButton() {
		let component = this.props.activeFilters ? (
			<Badge
				badgeContent={<Check className="badge-filter" />}
				secondary={true}
				badgeStyle={{ top: 12, right: 12, zIndex: 1 }}
			>
				<Tooltip title="Filtros" position="top" key={2}>
					<FloatingActionButton
						className="margin10"
						onClick={() => this.onToggledFilter()}
						zDepth={0}
					>
						<FilterList />
					</FloatingActionButton>
				</Tooltip>
			</Badge>
		) : (
			<Tooltip title="Filtros" position="top" key={2}>
				<FloatingActionButton
					className="margin10"
					onClick={() => this.onToggledFilter()}
					zDepth={0}
				>
					<FilterList />
				</FloatingActionButton>
			</Tooltip>
		);
		return component;
	}

	renderTouchTapNew() {
		return (
			<Tooltip title="Agregar nuevo registro" position="top">
				<FloatingActionButton
					onClick={this.props.onTouchTapNew}
					className="margin10"
					zDepth={0}
				>
					<ContentAdd />
				</FloatingActionButton>
			</Tooltip>
		);
	}

	renderOnTouchTapSearch() {
		return [
			<TextField
				key={1}
				value={this.props.InputValue}
				onChange={this.props.onChangeSearchField}
				floatingLabelText={
					this.props.labelSearchInput ? this.props.labelSearchInput : "Buscar"
				}
				onKeyPress={this.props.onKeyPressSearchField}
			/>,
			<Tooltip title="Buscar" position="top" key={2}>
				<FloatingActionButton
					className="margin10"
					onClick={this.props.onTouchTapSearch}
					zDepth={0}
				>
					<SearchIcon />
				</FloatingActionButton>
			</Tooltip>
		];
	}
	renderGenerateExel() {
		return (
			<RaisedButton
				icon={<LibraryBooks />}
				primary
				label={this.props.generateExcelLabel}
				onClick={this.props.onTouchGenerateExcel}
				className="right10"
			/>
		);
	}
	renderGenerateExelDDJJConcepts() {
		return (
			<RaisedButton
				icon={<LibraryBooks />}
				primary
				label={this.props.generateExcelLabelDDJJConcepts}
				onClick={this.props.onTouchGenerateExcelDDJJConcepts}
				className="right10"
			/>
		);
	}

	renderDownloadExcelExample() {
		return (
			<RaisedButton
				icon={<Description />}
				primary
				label={this.props.downloadExcelExampleLabel}
				onClick={this.props.onTouchDownloadExcelExample}
				className="right10"
			/>
		);
	}
	renderNewDDJJ() {
		return (
			<RaisedButton
				primary
				label={this.props.newDDJJLabel}
				onClick={this.props.onTouchNewDDJJ}
				className="right10"
			/>
		);
	}

	render() {
		return (
			<div className="columns-row-between ">
				<div className="columns-row-simple">
					<div className="columns-column-simple align-center">
						{!this.props.onTouchTapNew ? null : this.renderTouchTapNew()}
						{!this.props.onTouchGenerateExcel
							? null
							: this.renderGenerateExel()}
						{!this.props.onTouchGenerateExcelDDJJConcepts
							? null
							: this.renderGenerateExelDDJJConcepts()}
						{!this.props.onTouchNewDDJJ ? null : this.renderNewDDJJ()}
					</div>
					<div className="columns-column-simple top20">
						{!this.props.onTouchDownloadExcelExample
							? null
							: this.renderDownloadExcelExample()}
					</div>
					{this.props.children}
				</div>
				<div className="columns-column-simple align-center">
					{!this.props.onTouchTapSearch ? null : this.renderOnTouchTapSearch()}
					{!this.props.onToggledFilter ? null : this.renderFilterButton()}
				</div>
			</div>
		);
	}
}

export default FilterCard;



// WEBPACK FOOTER //
// ./src/components/FilterCard/FilterCard.js